import {
  AGREE_DISAGREE_TYPES,
  YES_NO_PREFER_NOT_TO_SAY_TYPES,
} from "./consultations";
import { formatAgreeDisagreeValue } from "./formatAgreeDisagreeValue";

export const replaceUnderscoresAndFormatRadioOption = (
  input: string,
  title: string,
): string => {
  if (
    input === AGREE_DISAGREE_TYPES.agree ||
    input === AGREE_DISAGREE_TYPES.disagree
  ) {
    return formatAgreeDisagreeValue(input, title);
  }

  if (
    input === YES_NO_PREFER_NOT_TO_SAY_TYPES.prefer_not_to_say ||
    input === YES_NO_PREFER_NOT_TO_SAY_TYPES.no ||
    input === YES_NO_PREFER_NOT_TO_SAY_TYPES.yes
  ) {
    return input === YES_NO_PREFER_NOT_TO_SAY_TYPES.prefer_not_to_say
      ? "I prefer not to say"
      : input.replace(/_/g, " ");
  }

  return input.replace(/_/g, " ");
};
